import './pager.scss';
import Choices from 'Choices';

class Pager {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-pager',
            selectAttr: 'select'
        };

        this.settings = Object.assign({}, settings, options);

        this.$pager = element;

        this.$pagerSelect = this.$pager.querySelector('[' + this.settings.initAttr + '="' + this.settings.selectAttr + '"]');
        this.selectBox = null;

        if (this.$pagerSelect === null) {
            console.error('no element found with [' + this.settings.initAttr + '="' + this.settings.selectAttr + '"]');
        }

        this.selectBox = new Choices(this.$pagerSelect, {
            itemSelectText: '',
            removeItemButton: false,
            renderSelectedChoices: 'always',
            searchEnabled: false,
            shouldSort: false
        });
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$pagerSelect.addEventListener('change', () => {
            const page = this.$pagerSelect.value;
            const uri = this.$pagerSelect.getAttribute('data-pager-href');
            const newUri = uri.replace('page=0', 'page=' + page);
            window.location.href = newUri;
        });
    }
}

export { Pager };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $pagers = $context.querySelectorAll('[data-pager="root"]');

    if ($pagers.length > 0) {
        for (let i = 0; i < $pagers.length; i++) {
            const $pager = new Pager($pagers[i]);
            $pager.initialize();
        }
    }
});
